import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { ZoningViewControllerDelegate, ZoningViewController } from "../../Screen/Zoning/ZoningViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { ZoningViewModel } from '../../Screen/Zoning/ZoningViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class ZoningCoordinator implements IndexCoordinatorDelegate, ZoningViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepzoneamento")
        return (<ProtectedRoute requiredPermissions={['prop.zoneamento.*']} path="/:base/zoneamento" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'prop.zoneamento.adicionar',
                    edit: 'prop.zoneamento.editar',
                    delete: 'prop.zoneamento.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Zoneamento"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new ZoningViewModel()
        return (<ProtectedRoute requiredPermissions={['prop.zoneamento.adicionar', 'prop.zoneamento.editar']} path="/:base/zoneamento/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<ZoningViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepzoneamento") {
            navigation.history.push(`zoneamento/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepzoneamento") {
            navigation.history.push(`zoneamento/cad/${idSelection}`);
            return;
        }
    }

}